"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useCommon;
const tslib_1 = require("tslib");
const broswer = tslib_1.__importStar(require("@futuweb/tool-browser"));
const vue_demi_1 = require("vue-demi");
function useCommon() {
    var _a, _b, _c, _d, _e, _f, _g;
    const uid = ((_d = (_c = (_b = (_a = require('@futuweb/fego-render')) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.variable) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.UID) || 0;
    const isPlatform = broswer.isNNPlatform();
    const launchMM = (_g = (_f = (_e = require('@futuweb/fego-render')) === null || _e === void 0 ? void 0 : _e.common) === null || _f === void 0 ? void 0 : _f.utils) === null || _g === void 0 ? void 0 : _g.launchMM;
    return {
        uid,
        isPlatform,
        /**
         * 打开弹窗
         * @param tplId
         */
        openDialog(tplId) {
            const that = (0, vue_demi_1.getCurrentInstance)();
            const { common: { behavior: { runBehaviour }, }, } = require('@futuweb/fego-render');
            runBehaviour(that, {
                type: 'operateComponent',
                value: '',
                tplId,
                methodName: 'open',
            });
        },
        // 登录
        jumpLogin(options) {
            const { common: { behavior: { runBehaviour }, }, } = require('@futuweb/fego-render');
            runBehaviour(this, Object.assign({
                type: 'login',
                value: location.href,
                withQuery: true,
                customData: 'invite',
            }, options));
        },
        /**
         * 更新fego变量
         * @param key
         * @param value
         */
        updateFegoVariable(key, value) {
            const { store: { variable: { data }, }, } = require('@futuweb/fego-render');
            console.log(`更新页面变量 key: ${key}, value: ${value}`);
            data[key] = value;
        }
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29tbW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsNEJBNERDOztBQTlERCx1RUFBaUQ7QUFDakQsdUNBQThDO0FBQzlDLFNBQXdCLFNBQVM7O0lBQzdCLE1BQU0sR0FBRyxHQUFXLENBQUEsTUFBQSxNQUFBLE1BQUEsTUFBQSxPQUFPLENBQUMsc0JBQXNCLENBQUMsMENBQUUsS0FBSywwQ0FBRSxRQUFRLDBDQUFFLElBQUksMENBQUUsR0FBRyxLQUFJLENBQUMsQ0FBQztJQUNyRixNQUFNLFVBQVUsR0FBWSxPQUFPLENBQUMsWUFBWSxFQUFFLENBQUM7SUFDbkQsTUFBTSxRQUFRLEdBQUcsTUFBQSxNQUFBLE1BQUEsT0FBTyxDQUFDLHNCQUFzQixDQUFDLDBDQUFFLE1BQU0sMENBQUUsS0FBSywwQ0FBRSxRQUFRLENBQUM7SUFDMUUsT0FBTztRQUNILEdBQUc7UUFDSCxVQUFVO1FBQ1Y7OztXQUdHO1FBQ0gsVUFBVSxDQUFDLEtBQWE7WUFDcEIsTUFBTSxJQUFJLEdBQUcsSUFBQSw2QkFBa0IsR0FBRSxDQUFDO1lBQ2xDLE1BQU0sRUFDRixNQUFNLEVBQUUsRUFDSixRQUFRLEVBQUUsRUFBRSxZQUFZLEVBQUUsR0FDN0IsR0FDSixHQUFHLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO1lBQ3BDLFlBQVksQ0FBQyxJQUFJLEVBQUU7Z0JBQ2YsSUFBSSxFQUFFLGtCQUFrQjtnQkFDeEIsS0FBSyxFQUFFLEVBQUU7Z0JBQ1QsS0FBSztnQkFDTCxVQUFVLEVBQUUsTUFBTTthQUNyQixDQUFDLENBQUM7UUFDUCxDQUFDO1FBQ0QsS0FBSztRQUNMLFNBQVMsQ0FBQyxPQUFhO1lBQ25CLE1BQU0sRUFDRixNQUFNLEVBQUUsRUFDSixRQUFRLEVBQUUsRUFBRSxZQUFZLEVBQUUsR0FDN0IsR0FDSixHQUFHLE9BQU8sQ0FBQyxzQkFBc0IsQ0FBQyxDQUFDO1lBQ3BDLFlBQVksQ0FDUixJQUFJLEVBQ0osTUFBTSxDQUFDLE1BQU0sQ0FDVDtnQkFDSSxJQUFJLEVBQUUsT0FBTztnQkFDYixLQUFLLEVBQUUsUUFBUSxDQUFDLElBQUk7Z0JBQ3BCLFNBQVMsRUFBRSxJQUFJO2dCQUNmLFVBQVUsRUFBRSxRQUFRO2FBQ3ZCLEVBQ0QsT0FBTyxDQUNWLENBQ0osQ0FBQztRQUNOLENBQUM7UUFDRDs7OztXQUlHO1FBQ0gsa0JBQWtCLENBQUksR0FBVyxFQUFFLEtBQVE7WUFDdkMsTUFBTSxFQUNGLEtBQUssRUFBRSxFQUNILFFBQVEsRUFBRSxFQUFFLElBQUksRUFBRSxHQUNyQixHQUNKLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUM7WUFDcEMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxlQUFlLEdBQUcsWUFBWSxLQUFLLEVBQUUsQ0FBQyxDQUFDO1lBQ25ELElBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxLQUFLLENBQUM7UUFDdEIsQ0FBQztLQUNKLENBQUM7QUFDTixDQUFDIn0=